import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { FileText, Shield, Download } from "lucide-react";
import { toast } from "sonner";

const downloadPdf = (inv) => {
  const tok = localStorage.getItem("f360_token");
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/billing/invoices/${inv.invoice_id}/pdf`, {
    headers: { Authorization: `Bearer ${tok}` },
  })
    .then((r) => r.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${inv.invoice_number}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    })
    .catch(() => toast.error("Download failed"));
};

export default function AdminInvoices() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/invoices").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="admin-invoices-page">
      <div>
        <div className="text-xs text-gray-500 flex items-center gap-1"><Shield className="w-3 h-3" strokeWidth={2.5} /> Platform Admin</div>
        <h1 className="text-3xl md:text-4xl font-extrabold flex items-center gap-2"><FileText className="w-7 h-7 text-orange-400" strokeWidth={2.5} /> All Invoices</h1>
        <p className="text-sm text-gray-500 mt-1">Cross-tenant invoice ledger</p>
      </div>
      <div className="glass p-6 rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-wider text-gray-500">
            <tr>
              <th className="text-left pb-2">Invoice #</th>
              <th className="text-left pb-2">Org</th>
              <th className="text-left pb-2">Period</th>
              <th className="text-right pb-2">Subtotal</th>
              <th className="text-right pb-2">GST</th>
              <th className="text-right pb-2">Total</th>
              <th className="text-left pb-2">Status</th>
              <th className="text-right pb-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((inv) => (
              <tr key={inv.invoice_id} className="border-t border-gray-200">
                <td className="py-2.5 font-mono text-xs">{inv.invoice_number}</td>
                <td className="text-xs text-gray-500">{inv.org_name || inv.org_id}</td>
                <td className="text-xs text-gray-500">{new Date(inv.period_start).toLocaleDateString()} – {new Date(inv.period_end).toLocaleDateString()}</td>
                <td className="text-right">₹{inv.subtotal_inr.toLocaleString("en-IN")}</td>
                <td className="text-right">₹{inv.gst_18pct.toLocaleString("en-IN")}</td>
                <td className="text-right font-bold">₹{inv.total_inr.toLocaleString("en-IN")}</td>
                <td><span className={`px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest font-bold ${inv.status === "paid" ? "bg-emerald-500/20 text-emerald-200" : inv.status === "issued" ? "bg-blue-500/20 text-blue-200" : inv.status === "overdue" ? "bg-red-500/20 text-red-200" : "bg-slate-500/20 text-slate-200"}`}>{inv.status}</span></td>
                <td className="text-right">
                  <button onClick={() => downloadPdf(inv)} data-testid={`download-${inv.invoice_number}`}
                    className="text-orange-300 hover:text-gray-900 text-xs inline-flex items-center gap-1">
                    <Download className="w-3 h-3" strokeWidth={2.5} /> PDF
                  </button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} className="text-center text-gray-500 py-6">No invoices yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
